import React from 'react';
import { useSelector } from 'react-redux';
import { BlameLogType } from '@debbie/common/dist/blamelog/index.js';
import { compareAddresses } from '@debbie/common/dist/index.js';
import AddressInput from '../../AddressInput.js';
import UserInfoEntity from './UserInfoEntity.js';
import THEME from '../../../theme.js';
const UserAddress = (props) => {
    const { details } = props.user;
    const lang = useSelector((s) => s.lang);
    const addresNotDeliverable = details.deliverability?.letter?.find((d) => compareAddresses(d.address, details.address) && d.success === false);
    return (React.createElement(UserInfoEntity, { title: lang.debtorInfo.address, tags: addresNotDeliverable
            ? [
                {
                    content: '!',
                    theme: THEME.WARNING,
                    tooltip: lang.debtorInfo.letterReturned,
                },
            ]
            : undefined, value: details.address, hist: details.addressHist, onChange: async (val) => { }, renderValue: (val) => (val && val.address && (React.createElement(React.Fragment, null,
            val.address,
            val.coAddress && `, c/o ${val.coAddress}`,
            ",",
            React.createElement("br", null),
            val.zipcode,
            " ",
            val.city,
            val.country && (React.createElement(React.Fragment, null,
                ",",
                React.createElement("br", null),
                " ",
                val.country))))) || React.createElement("span", { style: { opacity: 0.5 } }, lang.debtorInfo.noAddr), renderEditor: (selectedValue) => (React.createElement(AddressInput, { address: details.address, onChange: async (address) => {
                if ((address && address.address) || address === null) {
                    selectedValue(address);
                    await props.patchUser({
                        address,
                    }, {
                        details: address,
                        type: BlameLogType.DebtorUpdateAddress,
                    });
                }
            }, notUpdateOnEditingStateChange: true })), removable: true }));
};
export default UserAddress;
//# sourceMappingURL=UserAddress.js.map